import React from 'react';
import ReactDOM from 'react-dom/client';
import '@scenario-os/i18n/i18n';
import '@scenario-os/index.css';
import App from './App';
import { registerServiceWorker } from '@shared/utils/registerServiceWorker';
import { hideSplash, setStatusBarStyle, isNative } from '@shared/utils/native';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if (process.env.NODE_ENV === 'production') {
  registerServiceWorker('/service-worker.js');
}

// Phase 2 / Step H — Capacitor bring-up hooks. See learner-app/src/index.js
// for the full rationale; coach app behaves identically.
if (isNative()) {
  setStatusBarStyle({ style: 'dark' }).catch(() => {});
  setTimeout(() => hideSplash().catch(() => {}), 100);
}

